import { ApplicationInsights } from '@microsoft/applicationinsights-web';

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();

  const appInsights = new ApplicationInsights({
    config: {
      disablePageShowEvents: ['unload'],
      connectionString: config.public.APP_APPLICATION_INSIGHT
    }
  });

  if (config.public.APP_IS_PROD_ENV === 'enabled') appInsights.loadAppInsights();

  nuxtApp.provide('appInsights', appInsights);
});
